/**
 * Open a URL in the system browser.
 * Validates protocol (http/https only) to prevent arbitrary protocol execution.
 * Supports Electron (via IPC) and web (window.open).
 */
export function openExternalUrl(url: string): void {
  try {
    const parsed = new URL(url);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") return;
  } catch {
    return;
  }

  // Electron: IPC via preload-injected global
  const electronApi = (window as any).__electronApi;
  if (electronApi?.openExternalUrl) {
    electronApi.openExternalUrl(url).catch(() => {
      window.open(url, "_blank", "noopener,noreferrer");
    });
    return;
  }

  window.open(url, "_blank", "noopener,noreferrer");
}
